const bancoHeaders = [
    {
        label: 'Banco',
        field: 'banco',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const cuentaHeaders = [
    {
        label: 'Cuenta',
        field: 'tipo_cuenta',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const tipoFlotaHeaders = [
    {
        label: 'Flota',
        field: 'flota',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const empresasHeaders = [
    {
        label: 'Razón Social',
        field: 'razonSocial',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Sigla',
        field: 'sigla',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Jefe Flota',
        field: 'jefeFlota',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Telefono JF',
        field: 'telefonoJF',
        sortable: true,
        width: '100%'
    },
    // {
    //     label: 'Email JF',
    //     field: 'emailJf',
    //     sortable: true,
    //     width: '100%'
    // },
    // {
    //     label: 'Contacto Comercial',
    //     field: 'contactoComercial',
    //     sortable: true,
    //     width: '100%'
    // },
    // {
    //     label: 'Telefono Comercial',
    //     field: 'telefonoComercial',
    //     sortable: true,
    //     width: '100%'
    // },
    // {
    //     label: 'Email Comercial',
    //     field: 'emailComercial',
    //     sortable: true,
    //     width: '100%'
    // },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const tmsHeaders = [
    {
        label: 'TMS',
        field: 'tms',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const conductoresHeaders = [
    {
        label: 'Nombre',
        field: 'usuarioSpread',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Telefono',
        field: 'telefono',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Empresa',
        field: 'sigla',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Patente',
        field: 'ppu',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const centroDespachoHeaders = [
    {
        label: 'Nombre',
        field: 'centroDespacho',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const tipoVehiculoHeaders = [
    {
        label: 'Tipo Vehículo',
        field: 'tipo',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const vehiculoHeaders = [
    {
        label: 'PPU',
        field: 'ppu',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Tipo Vehículo',
        field: 'tipo',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Usuario Asignado',
        field: 'usuarioSpread',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const tipoDocumentoHeaders = [
    {
        label: 'Documento',
        field: 'documento',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Impuesto (%)',
        field: 'impuesto',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const bonosHeaders = [
    {
        label: 'Nombre',
        field: 'nombre',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Monto Sugerido',
        field: 'monto',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const descuentosHeaders = [
    {
        label: 'Nombre',
        field: 'nombre',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const bndHeaders = [
    {
        label: 'Nombre',
        field: 'nombre',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const remHeaders = [
    {
        label: 'Nombre',
        field: 'nombre',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const ifeHeaders = [
    {
        label: 'Nombre',
        field: 'nombre',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]

const cierreHeaders = [
    {
        label: 'Nombre',
        field: 'nombre',
        sortable: true,
        width: '100%'
    },
    {
        label: 'Detalles',
        field: 'addBtn'
    }
]   

export const tipoHeaders = (tipo) => {
    switch (tipo) {
        case 'banco':
            return bancoHeaders;
        case 'tipo_cuenta':
            return cuentaHeaders;
        case 'empresa':
            return empresasHeaders;
        case 'tipo_flota':
            return tipoFlotaHeaders;
        case 'tms':
            return tmsHeaders;
        case 'conductores':
            return conductoresHeaders;
        case 'centro_despacho':
            return centroDespachoHeaders;
        case 'tipo_vehiculo':
            return tipoVehiculoHeaders;
        case 'vehiculo':
            return vehiculoHeaders; 
        case 'tipo_documento':
            return tipoDocumentoHeaders;
        case 'ListaBonos':
        case 'ListaDescuentos':
        case 'ListaBnd':
        case 'ListaRem':
        case 'ListaIfe':
            return bonosHeaders;
        case 'cierre':
            return cierreHeaders;
        default:
            break;
    }
}